var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFocus2Fill = function SvgFocus2Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9m0 16.2a7.19 7.19 0 0 0 7.2-7.2A7.19 7.19 0 0 0 12 4.8 7.19 7.19 0 0 0 4.8 12a7.19 7.19 0 0 0 7.2 7.2m0-1.8A5.393 5.393 0 0 1 6.6 12c0-2.988 2.412-5.4 5.4-5.4s5.4 2.412 5.4 5.4-2.412 5.4-5.4 5.4m0-7.2c-.99 0-1.8.81-1.8 1.8s.81 1.8 1.8 1.8 1.8-.81 1.8-1.8-.81-1.8-1.8-1.8"
  })));
};
export default SvgFocus2Fill;